import React from 'react';
import { connect } from 'react-redux';
import { Form, Input, Button, Card } from 'antd';
import { login as loginAction } from '../redux/actions/authActions';
import AuthLayout from '../components/container/AuthLayout';

const ChangePassword = ({ auth, login }) => {
  const { isLoading } = auth;

  const onFinish = (values) => login(values);

  return (
    <AuthLayout>
      <Card title="Change Password" className="auth-card" hoverable>
        <Form layout="vertical" onFinish={onFinish} hideRequiredMark>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter new password' }]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please confirm password' }]}
          >
            <Input.Password placeholder="Confirm password" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" loading={isLoading} disabled={isLoading} htmlType="submit" block>
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </AuthLayout>
  );
};
const mapState = ({ auth }) => ({
  auth,
});
export default connect(mapState, { login: loginAction })(ChangePassword);
